/* @ngInject */
export default function GatesService($sails, $q, $log) {
  const vm = this;

  vm.getStatus = getStatus;
  vm.getSchedule = getSchedule;
  vm.setSchedule = setSchedule;
  vm.getOptions = getOptions;
  vm.performAction = performAction;
  vm.getMode = getMode;
  vm.processCurrentOption = processCurrentOption;
  vm.enableSchedule = enableSchedule;

  /**
   * Gets the status of the panel from the server.
   *
   * @param {object} equipment
   * @param {string} equipment.id
   * @returns {Promise<object>} Status
   */
  function getStatus({ id }) {
    return $q.all([
      getMode(id),
      getSchedule(id)
    ])
      .then(results => ({
        currentOption: results[0].data.status,
        schedule: results[1].data.schedule,
        scheduleEnabled: results[1].data.enabled
      }));
  }

  /**
   * Gets the current mode of the gate.
   *
   * @param {string} equipmentId id of the equipment
   * @returns {Promise<object>} Mode
   */
  function getMode(equipmentId) {
    return $sails.get(`/equipment/${equipmentId}/statuses/getGateMode`)
      .catch(catchError);
  }

  /**
   * Gets all options for gates.  Action is what is accepted by performAction
   * function.
   *
   * @returns {Array} array of options
   */
  function getOptions() {
    return [{
      name: 'Hold Open',
      value: 'holdOpen',
      action: 'setGateHoldOpen'
    }, {
      name: 'Hold Close',
      value: 'holdClose',
      action: 'setGateHoldClose'
    }, {
      name: 'Keypad / Card',
      value: 'holdNormal',
      action: 'setGateNormal'
    }];
  }

  function performAction({ id }, action) {
    return $sails.post(`/equipment/${id}/actions/${action}`, {
      id
    })
      .catch(catchError);
  }

  /**
   * Get the schedule for the given equipment
   *
   * @param {string} id id of the equipment
   * @returns {Promise} promise
   */
  function getSchedule(id) {
    return $sails.get(`/equipment/${id}/statuses/getGateSchedule/`)
      .catch(catchError);
  }

  function setSchedule(id, schedule) {
    return $sails.post(`/equipment/${id}/actions/setGateSchedule/`, {
      schedule,
      id
    }).catch(catchError);
  }

  function enableSchedule(equipmentId, shouldEnable = true) {
    const action = shouldEnable ? 'enableGateSchedule' : 'disableGateSchedule';
    return performAction(equipmentId, action);
  }

  function processCurrentOption(values) {
    return { currentOption: values.gateModeState };
  }

  // private functions
  function catchError(error) {
    $log.log('Error: ', error);
    return $q.reject(error.data);
  }
}
